const imagePresetsConfig = {
  DEFUALT_PRESET: "?$mktg$",
  PDP_DESKTOP: "pdp_desktop",
  PDP_RETINA: "pdp_retina",
  PDP_MOBILE: "pdp_mobile",
  ZOOM_DESKTOP: "zoom_desktop",
  ZOOM_MOBILE: "zoom_mobile",
  PDP_THUMB: "pdp_thumb",
  TILE_DESKTOP: "tile_desktop",
  BAG_DESKTOP: "bag_desktop",
  QV_DESKTOP: "qv_desktop",
  MENS_BANDS_DESKTOP: "mensBands_desktop",
  STACK_IT_PDP_DESKTOP: "stack_desktop",
  STACK_IT_PDP_MOBILE: "stack_mobile",
}

export default imagePresetsConfig
